import { render } from "./UzhnetCardDanger.vue?vue&type=template&id=37925f90&scoped=true"
import script from "./UzhnetCardDanger.vue?vue&type=script&lang=js"
export * from "./UzhnetCardDanger.vue?vue&type=script&lang=js"

import "./UzhnetCardDanger.vue?vue&type=style&index=0&id=37925f90&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37925f90"]])

export default __exports__